import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { WelcomePageRoutingModule } from './welcome-routing.module';
import { WelcomePage } from './welcome.page';
import { ButtonModule } from 'common/components/button/button.module';
import { NgbScrollSpyModule } from '@ng-bootstrap/ng-bootstrap';
import { ViewCountFormatModule } from 'common/pipe/viewCountFormat/view-count-format.module';
import { DesktopFooterModule } from 'common/components/desktop-footer/desktop-footer.module';
import { ModalPopUpModule } from 'common/components/modal-pop-up/modal-pop-up.module';
import { SafePipeModule } from 'common/pipe/safe-pipe/safe.pipe.module';
import { InputModule } from 'common/components/input/input.module';

@NgModule({
    imports: [CommonModule, FormsModule, IonicModule, WelcomePageRoutingModule, ButtonModule, NgbScrollSpyModule, ViewCountFormatModule, DesktopFooterModule, ModalPopUpModule, SafePipeModule, InputModule],
    declarations: [WelcomePage],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class WelcomePageModule {}
